import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55 27.5C55 32.939 53.3872 38.2558 50.3654 42.7781C47.3437 47.3005 43.0487 50.8253 38.0237 52.9067C32.9988 54.9881 27.4694 55.5327 22.135 54.4716C16.8005 53.4105 11.9005 50.7915 8.05453 46.9456C4.20859 43.0996 1.58952 38.1995 0.528427 32.865C-0.532666 27.5305 0.0118858 22.0012 2.09329 16.9762C4.1747 11.9512 7.69948 7.6562 12.2218 4.63446C16.7442 1.61271 22.061 0 27.5 0C34.7935 0 41.7881 2.89725 46.9454 8.05451C52.1026 13.2118 55 20.2066 55 27.5Z"
        fill="#4B1E78"
      />
      <path
        d="M43.8044 15.059C43.7644 14.7063 43.6019 14.3789 43.3451 14.1338C43.0884 13.8888 42.7538 13.7416 42.3997 13.7181C41.9971 13.6917 41.4438 13.6476 40.0743 13.6311L38.6444 15.1866L26.7853 27.799L21.6152 22.8688L19.0512 25.5353L27.1351 33.2353L40.8652 17.8759C40.7744 20.9488 40.3596 24.0037 39.6277 26.9896C36.9624 38.1282 28.9863 41.6568 27.508 42.2233C26.078 41.6667 18.0369 38.071 15.3837 26.9896C14.5381 23.5951 14.1217 20.108 14.144 16.6099C16.8885 16.303 23.1882 15.3724 26.904 13.0448C29.3632 14.357 32.019 15.2617 34.7679 15.7234L37.2319 13.0999C33.7823 12.5334 29.8179 11.5663 27.916 10.0703C27.6492 9.86129 27.32 9.74784 26.981 9.74805H26.8182C26.4792 9.74784 26.15 9.86129 25.8832 10.0703C22.8153 12.4804 15.2463 13.5222 12.5887 13.7202C12.237 13.7465 11.9055 13.8946 11.6514 14.1392C11.3974 14.3838 11.2367 14.7096 11.1972 15.0601C10.9344 19.3109 11.3535 23.5762 12.439 27.6945C15.7291 41.439 26.3364 45.0351 26.7874 45.1847C26.9384 45.2335 27.0962 45.2583 27.255 45.2583H27.7554C27.9145 45.2584 28.0727 45.2336 28.2241 45.1847C28.674 45.0384 39.2812 41.4445 42.5702 27.6945C43.656 23.5763 44.0757 19.311 43.8132 15.0601"
        fill="white"
      />
    </svg>
  );
}
